import React, { useReducer } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import TextField from './../TextField'
import Button from './../Button'
import Checkbox from './../Checkbox'

import './LoginCard.scss'

const LoginCard = ({ title, onSubmit }) => {
  const initialState = { username: '', password: '', rememberMe: false }
  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    initialState
  )

  const onChangeHandler = event => {
    const { name, value } = event.target
    setState({
      [name]: value
    })
  }

  const onSubmitHandler = event => {
    event.preventDefault()
    if (!isEmpty(username) && !isEmpty(password)) {
      onSubmit(state)
    }
  }

  const { username, rememberMe, password } = state
  return (
    <div className="LoginCard__container card">
      <div className="section">
        <div className="Header__container field">
          <h1>
            {title}
          </h1>
        </div>
        {/*<Notification className="is-danger" text={error} />*/}
        <form onSubmit={onSubmitHandler}>
          <div className="Username__container field">
            <TextField
              tabIndex={0}
              autoFocus={true} // eslint-disable-line
              label="Username"
              name="username"
              onChange={onChangeHandler}
              value={username}
              type="text"
            />
          </div>
          <div className="Password__container field">
            <TextField
              tabIndex={0}
              label="Password"
              name="password"
              onChange={onChangeHandler}
              value={password}
              type="password"
            />
          </div>
          <div className="RememberMe__container field">
            <Checkbox
              tabIndex={0}
              name="rememberMe"
              onChange={onChangeHandler}
              checked={rememberMe}
            >
              Remember Me
            </Checkbox>
          </div>
          <div className="Submit__container field">
            <Button
              isFullWidth
              className="is-primary"
              tabIndex={0}
              onClick={onSubmitHandler}
              disabled={isEmpty(state.username) || isEmpty(state.password)}
            >
              LOGIN
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

LoginCard.propTypes = {

  onSubmit: PropTypes.func,
  title: PropTypes.string
}

LoginCard.defaultProps = {
  title: '',
  onSubmit: () => {}
}

export default LoginCard
